import React from 'react';

const About = () => {
    return (
        <section className="about section" id="about">
            <div className="about__container container grid">
                <h2 className="section__title-1 reveal-up">About Me.</h2>

                <div className="about__perfil reveal-left">
                    <div className="about__image">
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/img/about-perfil.jpg`}
                            alt="Haider Masood"
                            className="about__img"
                            loading="lazy"
                        />
                        <div className="about__shadow"></div>
                        <div className="geometric-box"></div>
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/img/random-lines.svg`}
                            alt=""
                            aria-hidden="true"
                            className="about__line"
                            loading="lazy"
                        />
                        <div className="about__box"></div>
                    </div>
                </div>

                <div className="about__info reveal-right">
                    <p className="about__description">
                        I'm an <b>AI Engineer and Team Lead</b> currently at Entropic, where I lead a team
                        building production AI systems across healthcare, agriculture, enterprise automation,
                        and creative AI. My work spans the full stack — from training custom vision models
                        to shipping React-and-FastAPI products used by real organisations.
                    </p>

                    <p className="about__description">
                        My research background (MS AI, NUST) grounds the engineering in rigour —
                        including a peer-reviewed IEEE publication on knee osteoarthritis grading and
                        a thesis applying reinforcement learning to Pakistan-focused crop simulation.
                        I care about systems that are both technically sound and usable by the people they serve.
                    </p>

                    <div className="about__buttons">
                        <a
                            href="#contact"
                            className="button"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                            }}
                        >
                            <i className="ri-send-plane-line"></i> Work Together
                        </a>
                        <a
                            href="https://www.linkedin.com/in/haidermasood99/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="button__ghost"
                            aria-label="LinkedIn profile"
                        >
                            <i className="ri-linkedin-box-line"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
